<template>
  <admin-input-list-wrapper :is-fetched="isFetched">
    <template #button>
      <v-row no-gutters>
        <v-col cols="auto">
          <base-button
            :disabled="disabled"
            translation-path="button.addCategory"
            @click="showDialog('input', { name: '' }, true)"
          ></base-button>
        </v-col>
      </v-row>
    </template>
    <template #list>
      <v-row no-gutters>
        <v-col cols="5">
          <v-list dense>
            <v-list-item
              v-for="category in tasksCategories"
              :key="category.id"
              class="category-element px-2 hover-list-element"
              style="height: 45px"
            >
              <v-list-item-content>
                <v-list-item-title class="text-body-2 font-weight-regular">
                  <div class="text-truncate" :class="disabled ? 'text--disabled' : 'text--black'">
                    {{ category.name }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="ml-0">
                <dots-menu
                  :disabled="disabled"
                  font-size="19px"
                  :items="[{ name: 'edit' }, { name: 'delete' }]"
                  @edit="showDialog('input', category)"
                  @delete="showDialog('delete', category)"
                ></dots-menu>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </template>
    <template #dialogs>
      <main-dialog
        v-if="isDeleteCategoryDialogLoaded"
        :is-visible.sync="isDeleteCategoryDialogVisible"
        :loading="isDialogLoading"
        :body="$i18n.t('dialog.confirmCategoryDelete')"
        :title="$i18n.t('dialog.deleteCategory')"
        agree-text="dialog.agreeDelete"
        @agree="handleModalAction('delete')"
      ></main-dialog>
      <main-input-dialog
        v-if="isInputCategoryDialogLoaded"
        :is-visible.sync="isInputCategoryDialogVisible"
        :loading="isDialogLoading"
        :title-translation="$i18n.t(`dialog.${isNew ? 'addCategory' : 'editCategory'}`)"
        :agree-text="`${isNew ? 'dialog.agreeAdd' : 'dialog.agreeSave'}`"
        dialog-width="45%"
        @agree="handleModalAction(isNew ? 'add' : 'edit')"
        :inputs="inputCategory"
      >
        <template #name.input="slot">
          <v-col>
            <v-row no-gutters>
              <v-col cols="12">
                <data-input v-model="currentCategory.name" v-bind="slot" :rules="slot.rules"></data-input>
              </v-col>
            </v-row>
          </v-col>
        </template>
      </main-input-dialog>
    </template>
  </admin-input-list-wrapper>
</template>
<script>
import { get, call } from 'vuex-pathify';
import { capitalize } from '@/assets/js/utility';

import AdminInputListWrapper from '@/components/AdminInputListWrapper';
import DataInput from '@/components/DataInput';
import DotsMenu from '@/components/DotsMenu';

export default {
  name: 'TasksSettingsCategoriesList',
  components: {
    AdminInputListWrapper,
    DataInput,
    DotsMenu,
    MainDialog: () => import('@/components/MainDialog'),
    MainInputDialog: () => import('@/components/MainInputDialog'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentCategory: undefined,
    currentCategoryNameCopy: '',
    isDialogLoading: false,
    isDeleteCategoryDialogVisible: false,
    isDeleteCategoryDialogLoaded: false,
    isInputCategoryDialogVisible: false,
    isInputCategoryDialogLoaded: false,
    isFetched: false,
    isNew: false,
  }),
  computed: {
    tasksCategories: get('tasks/tasksCategories'),
    tasksCategoriesNames() {
      return this.tasksCategories.map(category => category.name);
    },
    inputCategory() {
      return [
        {
          name: 'name',
          translationPath: 'dialog.body.name',
          rules: [
            v => !!v || 'rules.required',
            v => !this.tasksCategoriesNames.includes(v) || v == this.currentCategoryNameCopy || 'rules.categoryExists',
          ],
          clearable: true,
          dataType: {
            name: 'text',
          },
        },
      ];
    },
  },
  methods: {
    addTasksCategory: call('tasks/addTasksCategory'),
    deleteTasksCategory: call('tasks/deleteTasksCategory'),
    editTasksCategory: call('tasks/editTasksCategory'),
    getTasksCategories: call('tasks/getTasksCategories'),
    hideDialog() {
      this.isDeleteCategoryDialogVisible = false;
      this.isInputCategoryDialogVisible = false;
      this.isDialogLoading = false;
    },
    showDialog(type, category, isNew = false) {
      this.isNew = isNew;
      this.currentCategoryNameCopy = JSON.parse(JSON.stringify(category.name));
      this.currentCategory = { ...category };
      this[`is${capitalize(type)}CategoryDialogLoaded`] = true;
      this[`is${capitalize(type)}CategoryDialogVisible`] = true;
    },
    async handleModalAction(type) {
      if (type === 'delete' && this.currentCategory.tasks_count > 0) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.dialog.categoryIsUsingInTask', {
            name: this.currentCategory.name,
          }),
        });
        this.hideDialog();
        return;
      } else if (type === 'delete' && this.tasksCategories.length < 2) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.dialog.cantDeleteLastCategory'),
        });
        this.hideDialog();
        return;
      }
      this.isDialogLoading = true;
      await this[`${type}TasksCategory`](this.currentCategory);
      this.hideDialog();
    },
    async init() {
      if (!this.disabled) {
        await this.getTasksCategories();
      }
      this.isFetched = true;
    },
  },
  watch: {
    disabled(nV) {
      if (!nV && this.tasksCategories.length < 1) {
        this.isFetched = false;
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.category-element {
  @include border();
  text-align: left;
}
</style>
